import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-commercial-property-insurance-v2.component.scss';
var FormItemBusinessCommercialPropertyInsuranceV2 = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessCommercialPropertyInsuranceV2, _super);
    function FormItemBusinessCommercialPropertyInsuranceV2(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessCommercialPropertyInsuranceV2.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-business-commercial-property-insurance__button');
        this.formModal = this.element.closest('.modal.js-apply-now-modal');
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        // display views
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
    };
    FormItemBusinessCommercialPropertyInsuranceV2.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.showDisplayView("");
        }, false);
    };
    FormItemBusinessCommercialPropertyInsuranceV2.prototype.submitForm = function (pForm) {
        var _this = this;
        var _firstname = this.form.querySelector("input[name=first-name]");
        var _lastName = this.form.querySelector("input[name=last-name]");
        var _cellNumber = this.form.querySelector("input[name=cell-number]");
        var _emailAddress = this.form.querySelector("input[name=email-address]");
        var _product = this.form.querySelector("input[name=product]");
        var _businessName = this.form.querySelector("input[name=business-name]");
        var _date = this.form.querySelector("input[name=date]");
        var _time = this.form.querySelector("select[name=time]");
        var dataPrivacyConsent = this.form.querySelector("input[name=popia-consent]");
        var _dateTime = "anytime";
        if (_date && _time) {
            if (_time.value !== "Anytime") {
                _dateTime = _date.value + " " + _time.value;
            }
        }
        var _postData = {
            'first': (_firstname ? _firstname.value : ""),
            'last': (_lastName ? _lastName.value : ""),
            'cell': (_cellNumber ? _cellNumber.value : ""),
            'emailAddress': (_emailAddress ? _emailAddress.value : ""),
            'product': (_product ? _product.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'business-name': (_businessName ? _businessName.value : ""),
            'besttimetoCall': _dateTime,
            'dataPrivacyConsent': ((dataPrivacyConsent ? (dataPrivacyConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.getDataConsentValue(pForm, 'data-sharing-group'),
            'dataSharing3rdParty': this.getDataConsentValue(pForm, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.getDataConsentValue(pForm, 'data-sharing-boarders'),
        };
        this.showDisplayView("loader");
        // variables
        var url = '/bcbsadocumentupload/business-sme-insurance-lead';
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (response) {
            // service ok
            if (!response) {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
                _this.showDisplayView("error");
            }
            else if (response.data) {
                if (response.data.toString().toLowerCase().includes("invalid")) {
                    _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                    _this.showDisplayView("error");
                }
                else {
                    _this.analyticsService.dtmFormComplete('complete', response.data);
                    _this.showDisplayView("success");
                }
            }
            else {
                _this.analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
                _this.showDisplayView("error");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            _this.showDisplayView("error");
        });
    };
    FormItemBusinessCommercialPropertyInsuranceV2.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    FormItemBusinessCommercialPropertyInsuranceV2.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
                break;
        }
    };
    return FormItemBusinessCommercialPropertyInsuranceV2;
}(Base));
export { FormItemBusinessCommercialPropertyInsuranceV2 };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-commercial-property-insurance-v2/form-item-business-commercial-property-insurance-v2.component.ts
// module id = 859
// module chunks = 0